import { useCallback, useRef } from "react";

/**
 * Tracks IME composition so Enter is not treated as submit mid-composition.
 * Mirrors Sender composition handling.
 */
export function useSenderComposition() {
  const isComposingRef = useRef(false);

  const onCompositionStart = useCallback(() => {
    isComposingRef.current = true;
  }, []);

  const onCompositionEnd = useCallback(() => {
    isComposingRef.current = false;
  }, []);

  return { isComposingRef, onCompositionStart, onCompositionEnd };
}
